import styled from 'styled-components'

import Button from '../../shared/Button'

type BoardButtonProps = {
  $isBoardSelected: boolean
  $canUnselectSubprofiles: boolean
}

export const BoardButton = styled(Button)<BoardButtonProps>`
  position: relative;
  box-sizing: border-box;
  height: 50px;
  padding: 8px 16px 8px 56px;
  line-height: 34px;
  border-top: 1px solid var(--color-border-subtle);
  cursor: ${(props) => {
    return props.$isBoardSelected && !props.$canUnselectSubprofiles
      ? 'default'
      : 'pointer'
  }};
  outline: none;
  background-color: ${(props) =>
    props.$isBoardSelected && props.$canUnselectSubprofiles
      ? 'var(--color-bg-subtle)'
      : 'transparent'};
  border-bottom: none;
  border-left: none;
  display: block;
  border-right: none;
  text-align: left;
  width: 100%;

  &:hover {
    background-color: var(--color-bg-subtle);
  }

  &:focus {
    background-color: var(--color-bg-subtle);
    box-shadow: inset 0 1px 0 0 var(--color-border-subtle);
    outline-color: var(--color-focus);
    outline-offset: 1px;
  }
`

export const IconsContainer = styled.span`
  float: right;
  line-height: 30px;
`

export const BoardThumbnail = styled.img`
  position: absolute;
  top: 8px;
  left: 16px;
  width: 32px;
  height: 32px;
  border-radius: 4px;
`

export const SharedBoardIcon = styled.div`
  float: left;
  margin-left: 4px;
  color: #ced7df;
  font-size: 22px;
`

export const BoardIcon = styled.span<{ $isBoardSelected: boolean }>`
  display: inline-block;
  margin-left: 7px;
  font-size: 16px;
  visibility: hidden;
  color: var(--color-text-success);

  ${BoardButton}:hover & {
    visibility: visible;
  }
`

export const BoardName = styled.span`
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
`
